import { Vms } from '_lib/api';
import { Map } from 'leaflet';
import React, { FC, ReactElement } from 'react';

import PmvMarker from './markers/PmvMarker';

const Pmvs: FC<{ pmvs: Vms[]; mapRef: Map }> = ({ pmvs, mapRef }): ReactElement => {
  const locatedPmvs = pmvs.filter((vms) => vms.latitude && vms.longitude);

  return (
    <>
      {locatedPmvs.map((vms) => (
        <PmvMarker key={vms.id} vms={vms} mapRef={mapRef} />
      ))}
    </>
  );
};

export default React.memo(Pmvs);
